import {
  ApplicationConfig,
  provideZoneChangeDetection,
  APP_INITIALIZER,
  LOCALE_ID,
} from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideClientHydration, withEventReplay } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideToastr } from "ngx-toastr";
import { provideNgxMask } from "ngx-mask";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { AuthInterceptorService } from "@services/auth-interceptor.service";
import { BrowserstateInterceptor } from "./interceptors/browserstate.interceptor";
import { routes } from "./app.routes";
import { SessionService } from "@shared/components/core/stores/session.service";
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { registerLocaleData, DatePipe, CurrencyPipe } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeZh from '@angular/common/locales/zh';

registerLocaleData(localePt, 'pt-BR');
registerLocaleData(localeEs, 'es-ES');
registerLocaleData(localeFr, 'fr-FR');
registerLocaleData(localeDe, 'de-DE');
registerLocaleData(localeZh, 'zh-CN');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),
    provideNgxMask(),
    provideAnimationsAsync(),
    provideToastr({}),
    DatePipe,
    CurrencyPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BrowserstateInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (session: SessionService) => () => session.init(),
      deps: [SessionService],
      multi: true,
    },

    { provide: LOCALE_ID, useValue: 'pt-BR' },

    provideTranslateService({
      lang: 'pt',
      fallbackLang: 'pt',
      loader: provideTranslateHttpLoader({
        prefix: 'assets/languages/',
        suffix: '.json',
      }),
    }),
  ],
};
